import { render, staticRenderFns } from "./P0147.vue?vue&type=template&id=06822907&scoped=true&"
import script from "./P0147.vue?vue&type=script&lang=ts&"
export * from "./P0147.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06822907",
  null
  
)

export default component.exports